<template>
    <base-modal :visible="show" @close="$emit('close')" title="Create new tag">
        <tag-form
            :loading="create.loading"
            @cancel="$emit('close')"
            @submit="submit"/>
    </base-modal>
</template>

<script>
import { mapState } from 'vuex';
import TagForm from './TagForm.vue';

export default {
    components: { TagForm },
    props: ['space', 'show'],
    computed: mapState('columns', ['create']),
    methods: {
        async submit(data) {
            const tag = await this.$store.dispatch('tags/create', {
                space_id: this.space.id,
                data,
            });
            this.$store.commit('tags/add_tag', tag);
            this.$emit('close');
        },
    },
};
</script>
